export const formatNumber = (number: number): string | undefined => {
  if (number !== null && number !== undefined && !isNaN(number)) {
    try {
      return new Intl.NumberFormat('en-IE').format(number);
    } catch (_err) {
      return number?.toString() || undefined;
    }
  } else {
    return undefined;
  }
};
